/**
 * 逐笔成交
 */
import React, { useEffect, useState } from "react"
import { getBondZBCJData } from "../../../../modules/quote/web"
import { LoadStatus } from "../../load_status"
import { getSettleMethod, getSettlePeriod, returnTransactionMode, TransactionDataType, TransactionType } from "../../utils"

export function Transaction(props: { quotecode: string }) {
  const [currentType, setCurrentType] = useState(TransactionType.全部成交)
  const [pageSize, setPageSize] = useState(20)
  const [transactionData, setTransationData] = useState([])

  let currentTypeList = [TransactionType.全部成交, TransactionType.匹配成交, TransactionType.点击成交, TransactionType.询价成交, TransactionType.协商成交]

  let titleArr: Array<TransactionDataType> = []

  let fieldArr = [
    { tps: 0, fields2: "f51,f52,f53,f54" }, // 全部成交
    { tps: 1, fields2: "f51,f52,f53,f54,f55,f56" }, // 匹配成交
    { tps: 4, fields2: "f51,f52,f53,f54,f55,f56" }, // 点击成交
    { tps: 16, fields2: "f51,f52,f53,f54,f55,f56" }, // 询价成交
    { tps: 2, fields2: "f51,f52,f53,f54,f55,f56" }, // 协商成交
    { tps: 32, fields2: "f51,f52,f53,f54,f55,f56" }, // 竞买成交
  ]

  if (currentType == TransactionType.全部成交) {
    titleArr = [TransactionDataType.时间, TransactionDataType.成交价, TransactionDataType.成交量, TransactionDataType.交易方式]
  } else if (currentType == TransactionType.匹配成交 || currentType == TransactionType.点击成交 || currentType == TransactionType.询价成交 || currentType == TransactionType.协商成交) {
    titleArr = [TransactionDataType.时间, TransactionDataType.成交价, TransactionDataType.成交量, TransactionDataType.未知, TransactionDataType.结算方式, TransactionDataType.结算周期]
  }

  useEffect(() => {
    ;(async () => {
      let data = await getBondZBCJData(props.quotecode, fieldArr[currentType], pageSize)
      if (data?.data?.trans && data.data.trans.length) {
        let temp = data.data.trans.map((v: any) => {
          return v.split(",")
        })
        setTransationData(temp)
      } else {
        setTransationData([])
      }
    })()
  }, [currentType, pageSize])

  return (
    <>
      <div className="stock-bj-deal">
        <dl className="stock-bj-deal-nav">
          {currentTypeList.map((item: any) => {
            return (
              <dd
                className={item == currentType ? "bj-tab-active" : ""}
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentType(item)
                }}
                key={item}
              >
                <span>{TransactionType[item]}</span>
              </dd>
            )
          })}
        </dl>
        {transactionData.length > 0 && (
          <div className="stock-bj-table">
            <table cellPadding="0" cellSpacing="0" width="100%">
              <thead>
                <tr>
                  {titleArr.map((item: number,index:number) => {
                    if (item != 99) return <th key={item} className={index == 0 ? "fixed-colume" : ""}>{TransactionDataType[item]}</th>
                  })}
                </tr>
              </thead>
              <tbody>
                {transactionData.map((item: any, index: number) => {
                  return (
                    <tr key={index}>
                      {item.map((v: any, i: number) => {
                        return (
                          <React.Fragment key={i}>
                            {i == titleArr[0] && <td className="fixed-colume">{item[0]}</td>}
                            {i == titleArr[1] && <td>{item[1]}</td>}
                            {i == titleArr[2] && <td>{item[2]}</td>}
                            {i == titleArr[3] && <td>{returnTransactionMode(item[3])}</td>}
                            {i == titleArr[4] && <td>{getSettleMethod(item[4])}</td>}
                            {i == titleArr[5] && <td>{getSettlePeriod(item[5])}</td>}
                          </React.Fragment>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {transactionData.length > 0 &&
        (pageSize == transactionData.length ? (
          <div
            className="stock-bj-loadmore"
            onClick={(e) => {
              e.preventDefault()
              setPageSize(pageSize + 10)
            }}
          >
            查看更多
            <i className="arrow-down"></i>
          </div>
        ) : (
          <LoadStatus icon={false} className="com_tips" title="已经加载到底了" />
        ))}
      {transactionData.length == 0 && <LoadStatus icon={false} className="com_tips" title="该品种暂无相关内容" />}
    </>
  )
}
